import styled from "styled-components";

export const ArticleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const ListHeader = styled.thead`
  text-align: left;
  color: #111;
  font-size: 16px;
  background: ${({ theme }) => theme.light};

  & tr {
    background: ${({ theme }) => theme.light};

    & th {
      padding: 10px 5px;

      &:not(:first-child) {
        display: none;
      }
    }
  }

  @media (min-width: 480px) {
    width: 100%;
    margin-bottom: 5px;

    & tr th:first-child {
      display: none;
    }

    & tr th:not(:first-child) {
      display: table-cell;
    }

    & th {
      padding: 10px 5px;
    }
  }
`;

export const ListBody = styled.tbody`
  display: flex;
  flex-direction: column;

  @media (min-width: 480px) {
    display: table-row-group;
  }
`;
